<template>
	<div class="layout__item u-1/1">
		<h4 class="c-filter-section__sub-heading mb--">
			{{ title }}
			<info-text :info-text="infoText"></info-text>
		</h4>

		<div
			class="u-1/1"
			v-for="v in filterValues"
			:class="{ 'ml+ u-2/3-palm': v.Value === 'GreenNl' }"
			:key="v.Value"
		>
			<template v-if="v.Value !== 'geen'">
				<input
					type="checkbox"
					v-model="v.IsSelected"
					class="c-inputfields__input--checkbox"
					@change="updateValues(v.Value)"
					:id="v.Value"
					:value="v.Value"
				/>

				<label :for="v.Value" class="c-inputfields__label">{{ v.Text }}</label>
			</template>
		</div>
		<div class="ml+ u-2/3-palm">
			<input
				type="checkbox"
				v-model="NoBioMassFilter"
				id="NoBioMassFilter"
				class="c-inputfields__input--checkbox"
				@change="updateBioMassFilter()"
			/>
			<label for="NoBioMassFilter" class="c-inputfields__label">
				Vrij van <abbr v-tooltip="NoBioMassFilterText">biomassa</abbr>
			</label>
		</div>
	</div>
</template>

<script>
import InfoText from '@/partials/InfoText';
export default {
	components: { InfoText },
	props: {
		filterValues: Array,
		title: String,
		infoText: String,
		allNone: Boolean
	},
	data() {
		return {
			NoBioMassFilter: false,
			NoBioMassFilterText: `Stroom uit biomassa is opgewekt uit de verbranding van natuurlijke materialen, zoals afval, mest, (rest)hout, pallets, etc.
<br /> <br />
Deze vorm van energieopwekking wordt niet altijd als even duurzaam beschouwd doordat bijvoorbeeld ontbossing, transport en CO2-uitstoot een negatieve invloed heeft op het milieu.`
		};
	},
	methods: {
		updateBioMassFilter() {
			let greenCheckbox = this.filterValues.find(fV => fV.Value === 'Green');
			if (this.NoBioMassFilter && !greenCheckbox.IsSelected) {
				greenCheckbox.IsSelected = true;
			}
			this.updateValues();
		},
		updateValues(originValue) {
			let greenCheckbox = this.filterValues.find(fV => fV.Value === 'Green');
			let greenNlCheckbox = this.filterValues.find(fV => fV.Value === 'GreenNl');
			if (originValue) {
				if (originValue === 'Green' && !greenCheckbox.IsSelected) {
					greenNlCheckbox.IsSelected = false;
					this.NoBioMassFilter = false;
				}
				if (originValue === 'GreenNl' && greenNlCheckbox.IsSelected) {
					greenCheckbox.IsSelected = true;
				}
			}

			let values = this.filterValues
				.filter(fV => fV.IsSelected)
				.map(fV => fV.Value)
				.join(',');
			if (greenNlCheckbox.IsSelected) {
				values = values.replace('Green,', '').replace('geen,', '');
			}
			if (greenCheckbox.IsSelected) {
				values = values.replace('geen,', '');
			}
			this.$emit('valuechange', { origin: values, NoBioMassFilter: this.NoBioMassFilter });
		}
	}
};
</script>

<style></style>
